module.exports = __webpack_public_path__ + "img/AFMS_HARSH.12f3a08a.png";